module.exports = __webpack_public_path__ + "assets/img/star_sentence_un_select9.ee314bdb.png";